<template>
<div>
    <div class="diagram-two-wrap" :style="{ height: winHeight - 100 + 'px' }" ref="total">
        <div id="main" ref="main" class="total-wrap">
            <div
                id="canvas"
                ref="canvas"
                class="canvas-wrap"
                :style="
                    `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                "
            >
                <img class="bg-img" src="../../../../assets/image/app/xbj-01.svg" alt srcset />
                <!-- <div class="total-title">MO1#变系统图</div> -->
                  <div
                        v-for="item in mo_datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                        @click="showDialog(item)"
                    >
                        <div class="data-item">
                            <div class="data-name red">ia</div>
                            <div class="data-number">
                                {{ item.ia }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name yellow">ib</div>
                            <div class="data-number">
                                {{ item.ib }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name green">ic</div>
                            <div class="data-number">
                                {{ item.ic }}
                                <span>A</span>
                            </div>
                        </div>
                    </div>
            
                    <div
                        v-for="item in mo_datas"
                        :key="item.switch_id"
                        class="top-switch"
                        :style="`top:${item._top}%;left:${item._left}%;`" @click="showTempDialog(item)"
                    >
                        <template v-if="item.isOn == 0">
                            <img
                               
                                src="../../../../assets/image/app/switch-on.svg"
                                alt
                                srcset
                                class="kaiguan"
                            />
                             </template>
                              <template v-else>
                                <img 
                                    src="../../../../assets/image/app/switch-off.svg"
                                    alt
                                    srcset
                                    class="kaiguan"
                                />
                            
                        </template>
                       
                    </div>
                    
            </div>
        </div>
        <diagramDialog :dialogVisible.sync="dialogVisible" :id="data_id" />
        <diagramDialog :dialogVisible.sync="dialogTempVisible" :id="switch_power_id" />
    </div>
    
</div>
</template>
<script>

import diagramDialog from "./components/diagram-dialog.vue";
import * as api from "@/http/api-runtime.js";
import { getNewestPower } from "@/http/api";
export default {
    components: { diagramDialog},
    data() {
        return {
           left: "0",
            top: "-20",
            scale: 0.9,
            width: 1200,
            height: 1000,
            winHeight: 0,
            dialogVisible: false,
            data_id: "",
            dialogTempVisible: false,
            data_temp_id: "",
            switch_power_id: "",
            timer: null,
            mo_datas: [
                {
                    name: "401",
                    point_id: "1465926956099866624",
                    switch_id: "sunsu_000000000000001",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                   _top: 16.4,
                    _left:4.8, 
                    top:43, 
                    left:4, 
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4101",
                    point_id: "1465931307677683712",
                    switch_id: "sunsu_000000000000002",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    _top:16.4,
                    _left:16.75, 
                    top: 43,
                    left:14,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4102",
                    point_id: "1465931515392200704",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    switch_id: "sunsu_000000000000003",
                     _top: 16.4,
                    _left:24.85, 
                    top: 43,
                    left:22,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4103",
                    point_id: "1465931666504585216",
                    switch_id: "sunsu_000000000000004",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                      _top: 16.4,
                    _left:32.3, 
                    top: 43,
                    left:29.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4104",
                    point_id: "1465931762960994304",
                    switch_id: "sunsu_000000000000005",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                     _top: 16.4,
                    _left:39.37, 
                    top:43,
                    left: 36,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4105",
                    point_id: "1465950021500309504",
                    switch_id: "sunsu_000000000000006",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    _top: 16.4,
                    _left:45.9, 
                    top: 43,
                    left:43,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4106",
                    point_id: "1465952017322119168",
                   switch_id: "sunsu_000000000000007",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    _top: 16.4,
                    _left:52.37, 
                    top:43,
                    left:50,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4108",
                    point_id: "1465952248256303104",
                    switch_id: "sunsu_000000000000008",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    _top: 16.4,
                    _left:68.9, 
                    top: 43,
                    left: 66,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4109",
                    point_id: "1465952427738959872",
                    switch_id: "sunsu_000000000000009",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    _top: 16.4,
                    _left:76.58, 
                    top:43,
                    left: 74,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4110",
                    point_id: "1465952589018337280",
                   switch_id: "sunsu_000000000000010",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    _top: 16.4,
                    _left:84.49, 
                    top:43,
                    left:82,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4111",
                    point_id: "1465955300916891648",
                    switch_id: "sunsu_000000000000011",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    _top: 16.4,
                    _left:92.20, 
                    top: 43,
                    left: 89,
                    ia: "",
                    ib: "",
                    ic: ""
                },
           
                 {
                    name: "4112",
                    point_id: "1465957622388658176", 
                    switch_id: "sunsu_000000000000012",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                     _top:66.1,
                    _left:91.45, 
                  top:95,
                    left:90,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4113",
                    point_id: "1465950021500309504",
                    switch_id: "sunsu_000000000000013",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                     _top:66.1,
                    _left:82.32, 
                    top:95,
                    left:79,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4114",
                    point_id: "1465952017322119168",
                    switch_id: "sunsu_000000000000014",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                     _top:66.1,
                    _left:72.22, 
                    top:95,
                    left:69,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4115",
                    point_id: "1465958645429735424",
                    switch_id: "sunsu_000000000000015",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                     _top:66.1,
                    _left:61.85, 
                   top:95,
                    left:59,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4116",
                    point_id: "1465958789667655680",
                    switch_id: "sunsu_000000000000016",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                     _top:66.1,
                    _left:51.86, 
                   top:95,
                    left:49,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4117",
                    point_id: "1465958988502831104",
                    switch_id: "sunsu_000000000000017",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                     _top:66.1,
                    _left:42.41, 
                   top:95,
                    left:39,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                
                 {
                    name: "4118",
                    point_id: "1465959152168767489",
                    switch_id: "sunsu_000000000000018",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                      _top:66.1,
                    _left:33.12, 
                    top:95,
                    left:31,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4119",
                    point_id: "1465969092610527232",
                    switch_id: "sunsu_000000000000019",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    _top:66.1,
                    _left:24.31, 
                    top:96,
                     left:21,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4120",
                    point_id: "1465969245870395392", 
                    switch_id: "sunsu_000000000000020",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    _top:66.1,
                    _left:16.11, 
                     top:96,
                    left:13,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4121",
                    point_id: "1465969387218440192",
                    switch_id: "sunsu_000000000000021",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    _top:66.1,
                    _left:5.60, 
                    top:96,
                    left:1,
                    ia: "",
                    ib: "",
                    ic: ""
                },
            ]

        };
    },
    created() {
        if (window.innerHeight) {
            this.winHeight = window.innerHeight;
        }
        else if (document.body && document.body.clientHeight) {
            this.winHeight = document.body.clientHeight;
        }
    },

    mounted() { 
        this.zoom();
        this.drag();
         this.setTimer();
        // 获取mo实时电数据
        this.getMoElecData();
        // 获取mo实时温度数据
       // this.getMoTempData(); 
       //获取MO开关
        this.getWarnSwitch();
    },
     methods: {
          setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                // 获取mo实时电数据
                this.getMoElecData();
                // 获取mo实时温度数据
                //this.getMoTempData();
                // 获取mo开关
                this.getWarnSwitch();
            }, 1000 * 60);
        },
        /**
        * @description: 获取mo实时电数据
        */
        getMoElecData() {
            let pointIds = [];
            this.mo_datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.mo_datas.forEach(item => {
                    let point = valueJson[item.point_id];
                  item.ia = point && point["a_a"] && this.fixedString(point["a_a"], 2);
                   item.ib = point && point["a_b"] && this.fixedString(point["a_b"], 2);
                   item.ic = point && point["a_c"] && this.fixedString(point["a_c"], 2);
                })
            })
        },


//开关开关
   getWarnSwitch() {
            let powerIds = [];
            this.mo_datas.forEach(item => {
                powerIds.push(item.switch_id);
            });
            api.getWarnSwitch(powerIds).then(res => {
                let valueJson = res.bus_json; 
                this.mo_datas.forEach(item => { 
                 let point = valueJson[item.switch_id];
                  item.isOn = point && point["kgl"];
                })
            })
        }, 

        /**
        * @description: 获取mo实时温度数据
        */
        // getMoTempData() {
        //     let pointIds = [];
        //     this.temp_datas.forEach(item => {
        //         pointIds.push(item.point_id);
        //     });
        //     api.getDataAll(pointIds).then(res => {
        //         let valueJson = res.bus_json;
        //         this.temp_datas.forEach(item => {
        //             let point = valueJson[item.point_id];
        //             item.ta = point && point["t_a"] && this.fixedString(point["t_a"], 0);
        //             item.tb = point && point["t_b"] && this.fixedString(point["t_b"], 0);
        //             item.tc = point && point["t_c"] && this.fixedString(point["t_c"], 0);
        //         })
        //     })
        // },
      
     
        /**
        * @description: 保留几位小数  number位数
        */
        fixedString(value, number) {
            let val = value + "";
            if (number == 0) {
                const arr = val.split(".");
                if (arr.length > 0) {
                    return arr[0];
                } else {
                    return "";
                }
            }
            return val.substring(0, val.indexOf(".") + (1 + number));

        },
        showDialog(item) {
            this.dialogVisible = true;
            this.data_id = item.point_id;
        },
        showTempDialog(item) {
            this.dialogTempVisible = true;
            this.switch_power_id = item.switch_id;  
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function (event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function (event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function (en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function (en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function () {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        },
    },
       destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
.diagram-two-wrap {
    background-color: #09292f;
    width: 98%;
    overflow: hidden;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    .total-wrap {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: move;
        .canvas-wrap {
            width: 100%;
            position: absolute;
             box-sizing: border-box;
            left: 0;
            top: 0;
            .bg-img {
                    width: 100%;
                    height: 100%;
                }
        }
       .top-switch {
               cursor: pointer;
                transform: scale(1);
                position: absolute;
                text-align: center;
                display: flex;
                // height: 20%;
                overflow: hidden;
                .top-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }
        .total-title {
            color: #fff;
            position: absolute;
            font-size: 24px;
            text-align: center;
            top: 1%;
            left: 50%;
            transform: translateX(-50%);
        }
        .bg-img {
            width: 100%;
        }
         .data-wrap {
            position: absolute;
            display: grid;
            transform: scale(1);
            cursor: pointer;

            .data-item {
                display: flex;
                margin-bottom: 0.2rem;

                .data-name {
                    align-self: center;
                    font-size: 1rem;
                    margin-right: 0.1rem;
                    width: 1rem;
                    text-align: right;
                    font-weight: bold;
                }

                .data-number {
                    font-size: 0.8rem;
                    width: 5rem;
                    text-align: right;
                     background-color: #0e4b69;
                    color: #fff;
                    height: 1rem;
                    line-height: 1rem;
                  //margin-left: 0.4rem;
                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                }

                .red {
                    color: #fe0101;
                }

                .yellow {
                    color: #fefa00;
                }

                .green {
                    color: #00b200;
                }
            }
            .data-item-temp {
                display: flex;
                margin-bottom: 0.3rem;

                .data-name-temp {
                    align-self: center;
                    font-size: 1rem;
                    margin-right: 0.1rem;
                    width: 1rem;
                    text-align: right;
                    font-weight: bold;
                }
             
                .data-number-temp {
                    font-size: 0.8rem;
                    width: 5rem;
                    text-align: right;
                    // background-color: #114aa5;
                    color: #fff;
                    height: 1.2rem;
                    line-height: 1.2rem;

                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                } 
                .red {
                    color: #fe0101;
                }

                .yellow {
                    color: #fefa00;
                }

                .green {
                    color: #00b200;
                }
            }
        }
    }
}
</style>
